module.exports = __webpack_public_path__ + "static/img/jwsp.8f354c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jwsp.jpg
// module id = hht9
// module chunks = 0